import { Link } from 'gatsby';
import React, { FC } from 'react';
import * as styles from './FooterList.module.scss';

interface FooterListProps {
  title: string;
  items: {
    label: string;
    path: string;
  }[]
}

const FooterList: FC<FooterListProps> = ({ title, items }) => {
  return (
    <ul className={styles.list}>
      <h4 className={styles.title}>{title}</h4>
      {items.map((item, i) => 
        <li key={i} className={styles.item}>
          <Link to={item.path} className={styles.link}>
            {item.label}
          </Link>
        </li>)}
    </ul>
  );
};

export default FooterList;